var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1253 0C11.8887 0.00160297 10.6988 0.472536 9.79611 1.31764C8.89339 2.16274 8.34511 3.319 8.26207 4.55278C7.26859 4.69577 6.33669 5.11977 5.5762 5.77482C4.81571 6.42987 4.25832 7.28867 3.96973 8.25H14.0308C13.7435 7.29316 13.19 6.4378 12.4348 5.78384C11.6795 5.12987 10.7538 4.70429 9.76573 4.55681C9.84861 3.69404 10.2602 2.89622 10.9153 2.32869C11.5704 1.76115 12.4188 1.4674 13.2845 1.5083C14.1503 1.54921 14.9672 1.92163 15.5658 2.54841C16.1645 3.17518 16.4991 4.00826 16.5003 4.875V18H18.0003V4.875C17.9988 3.58252 17.4847 2.34339 16.5708 1.42947C15.6569 0.515549 14.4177 0.00146398 13.1253 0V0Z",
    fill: "#AAB2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9H15V10.5H3V9Z",
    fill: "#AAB2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 17.25C9.41422 17.25 9.75001 16.9142 9.75001 16.5C9.75001 16.0858 9.41422 15.75 9.00001 15.75C8.58579 15.75 8.25 16.0858 8.25 16.5C8.25 16.9142 8.58579 17.25 9.00001 17.25Z",
    fill: "#AAB2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 15C9.41422 15 9.75001 14.6642 9.75001 14.25C9.75001 13.8358 9.41422 13.5 9.00001 13.5C8.58579 13.5 8.25 13.8358 8.25 14.25C8.25 14.6642 8.58579 15 9.00001 15Z",
    fill: "#AAB2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.25C12.4142 17.25 12.75 16.9142 12.75 16.5C12.75 16.0858 12.4142 15.75 12 15.75C11.5858 15.75 11.25 16.0858 11.25 16.5C11.25 16.9142 11.5858 17.25 12 17.25Z",
    fill: "#AAB2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15C12.4142 15 12.75 14.6642 12.75 14.25C12.75 13.8358 12.4142 13.5 12 13.5C11.5858 13.5 11.25 13.8358 11.25 14.25C11.25 14.6642 11.5858 15 12 15Z",
    fill: "#AAB2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 17.25C6.41421 17.25 6.75 16.9142 6.75 16.5C6.75 16.0858 6.41421 15.75 6 15.75C5.58579 15.75 5.25 16.0858 5.25 16.5C5.25 16.9142 5.58579 17.25 6 17.25Z",
    fill: "#AAB2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15C6.41421 15 6.75 14.6642 6.75 14.25C6.75 13.8358 6.41421 13.5 6 13.5C5.58579 13.5 5.25 13.8358 5.25 14.25C5.25 14.6642 5.58579 15 6 15Z",
    fill: "#AAB2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 12.75C9.41422 12.75 9.75001 12.4142 9.75001 12C9.75001 11.5858 9.41422 11.25 9.00001 11.25C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9.00001 12.75Z",
    fill: "#AAB2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75C12.4142 12.75 12.75 12.4142 12.75 12C12.75 11.5858 12.4142 11.25 12 11.25C11.5858 11.25 11.25 11.5858 11.25 12C11.25 12.4142 11.5858 12.75 12 12.75Z",
    fill: "#AAB2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.75C6.41421 12.75 6.75 12.4142 6.75 12C6.75 11.5858 6.41421 11.25 6 11.25C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75Z",
    fill: "#AAB2B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowers);
export default __webpack_public_path__ + "static/media/showers.21315a6a248e9a051a9024a8490acbf2.svg";
export { ForwardRef as ReactComponent };